import React, { useState } from 'react';
import { Delete } from 'lucide-react';
import Button from './Button';

const Calculator: React.FC = () => {
  const [display, setDisplay] = useState('0');
  const [previousValue, setPreviousValue] = useState<number | null>(null);
  const [operation, setOperation] = useState<string | null>(null);
  const [waitingForOperand, setWaitingForOperand] = useState(false);

  const inputDigit = (digit: string) => {
    if (waitingForOperand) {
      setDisplay(digit);
      setWaitingForOperand(false);
    } else {
      setDisplay(display === '0' ? digit : display + digit);
    }
  };

  const inputDecimal = () => {
    if (waitingForOperand) {
      setDisplay('0.');
      setWaitingForOperand(false);
    } else if (display.indexOf('.') === -1) {
      setDisplay(display + '.');
    }
  };

  const clear = () => {
    setDisplay('0');
    setPreviousValue(null);
    setOperation(null);
    setWaitingForOperand(false);
  };

  const performOperation = (nextOperation: string) => {
    const inputValue = parseFloat(display);

    if (previousValue === null) {
      setPreviousValue(inputValue);
    } else if (operation) {
      const currentValue = previousValue || 0;
      const newValue = calculate(currentValue, inputValue, operation);
      setDisplay(String(newValue));
      setPreviousValue(newValue);
    }

    setWaitingForOperand(true);
    setOperation(nextOperation);
  };

  const calculate = (first: number, second: number, op: string): number => {
    switch (op) {
      case '+':
        return first + second;
      case '-':
        return first - second;
      case '*':
        return first * second;
      case '/':
        return first / second;
      default:
        return second;
    }
  };

  const buttons = [
    ['7', '8', '9', '/'],
    ['4', '5', '6', '*'],
    ['1', '2', '3', '-'],
    ['0', '.', '=', '+'],
  ];

  return (
    <div className="w-full max-w-xs mx-auto">
      <div className="bg-gray-100 p-4 rounded-lg mb-4">
        <div className="text-right text-3xl font-bold" style={{ fontFamily: 'var(--font-family)' }}>
          {display}
        </div>
      </div>
      <div className="grid grid-cols-4 gap-2 mb-2">
        {buttons.flat().map((btn) => (
          <button
            key={btn}
            onClick={() => {
              if (btn === '=') {
                performOperation('=');
              } else if (['+', '-', '*', '/'].includes(btn)) {
                performOperation(btn);
              } else if (btn === '.') {
                inputDecimal();
              } else {
                inputDigit(btn);
              }
            }}
            className={`
              p-4 rounded-lg font-semibold text-lg
              ${['+', '-', '*', '/'].includes(btn) ? 'bg-[var(--color-primary)] text-white' : 'bg-gray-200 text-gray-800'}
              ${btn === '=' ? 'bg-[var(--color-success)] text-white' : ''}
              hover:opacity-80 transition-opacity
            `}
            style={{ fontFamily: 'var(--font-family)' }}
          >
            {btn}
          </button>
        ))}
      </div>
      <Button variant="outline" fullWidth onClick={clear} icon={<Delete className="w-4 h-4" />}>
        Clear
      </Button>
    </div>
  );
};

export default Calculator;

